import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='Ryan Hill' dateTime='2021-12-14' tag='Memo' title='Affordability Program Changes'>
        <p>
          Hi everyone! My name is Ryan, and I oversee our Premium offering here at OneShop. I’m amazed by the response
          from the community over these past weeks from the announcement of our affordability program, and I’m proud to
          say that we just finished issuing the first credits from the program today.
        </p>
        <p>
          In fact, more than twice the number of customers as we expected were eligible for the program. In order to be
          an enduring business that can serve you all for years to come, we will need to make some tweaks to the
          program’s guidelines.
        </p>
        <p>
          We are committed to supporting our affordable pricing program, and will be modifying the criteria to exclude
          lucrative sellers who make large, infrequent sales, and better focus on new sellers and those who cannot
          afford OneShop.
        </p>
        <p>
          Expect more specifics to be released this week as we wait for some new changes to roll out across app stores.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
